import type { ErrorInfo, ReactNode } from 'react';
import React from 'react';
import router from 'next/router';

interface Props {
  redirectToPath: string;
  children?: ReactNode;
}

interface State {
  hasError: boolean;
}

/**
 * React Error Boundary 컴포넌트.
 * 자식 컴포넌트에서 발생하는 JavaScript 오류를 감지하고, 오류 발생 시 대체 UI를 표시합니다.
 */
export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
    this.handleReloadClick = this.handleReloadClick.bind(this);
  }
  public static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div style={{ display: 'grid', placeContent: 'center', marginTop: '4em', gap: '1em' }}>
          <h1>오류가 발생하였습니다. 아래 버튼을 클릭하여 페이지를 새로 고침해주세요.</h1>
          <div style={{ textAlign: 'center' }}>
            <button id="reload-button" onClick={this.handleReloadClick}>
              새로고침
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }

  private handleReloadClick() {
    // 주의: Electron 모드에서 아래 주석 처리된 방법을 모두 시도해보았지만 로그인 페이지(/)로 이동하는 증상 발생함.
    // router.push('/monitor', undefined, { shallow: false });
    // router.reload();
    // router.replace(router.asPath);
    router.push(`/redirect?to=${this.props.redirectToPath}`);
  }
}
